import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";
import {
  deleteRule,
  getRules,
  saveRule,
  enableRule,
  getRule,
  getRuleLogs,
  getRuleLogDetail,
  getRuleMetrics,
} from "../api/RuleApi";
import {
  activateFacebookPage,
  activateInstagramPage,
  getAppLink,
  getAppLinks,
  getCurrentFacebookPages,
  getCurrentInstagramPages,
} from "../api/AppLinkApi";

const api = {
  [ActionTypes.getRules]: (projectId) => getRules(projectId),
  [ActionTypes.getAppLinks]: () => getAppLinks(),
  [ActionTypes.setDefaultPageApp]: (appId) => {
    if (appId !== "facebook" && appId !== "instagram") return;
    return getAppLink(appId).then((data) => {
      if (data?.connected && !data?.data?.page_id && data?.type === "facebook") {
        getCurrentFacebookPages().then((data) => {
          const firstPageId = (data || []).length > 0 ? (data || [])[0].id : null;
          if (firstPageId) {
            activateFacebookPage(firstPageId);
          }
        });
      } else if (data?.connected && !data?.data?.page_id && data?.type === "instagram") {
        getCurrentInstagramPages().then((data) => {
          const firstPageId = (data || []).length > 0 ? (data || [])[0].id : null;
          if (firstPageId) {
            activateInstagramPage(firstPageId);
          }
        });
      }
    });
  },
  [ActionTypes.saveRule]: (rule) => saveRule(rule),
  [ActionTypes.deleteRule]: (ruleId) => deleteRule(ruleId),
  [ActionTypes.getRule]: (ruleId) => getRule(ruleId),
  [ActionTypes.enableRule]: (ruleId) => enableRule(ruleId),
  [ActionTypes.setCurrentRule]: (rule) => rule,
  [ActionTypes.setPlatformProfile]: (payload) => payload,
  [ActionTypes.getRuleLogs]: (ruleId: string, page: number, size: number) =>
    getRuleLogs(ruleId, page, size),
  [ActionTypes.getRuleLogDetail]: (ruleId: string, logId: string) =>
    getRuleLogDetail(ruleId, logId),
  [ActionTypes.getRuleMetrics]: (ruleId: string) => getRuleMetrics(ruleId),
  [ActionTypes.setRuleLogDetail]: (payload: unknown) => payload,
  [ActionTypes.clearRuleLogs]: () => null,
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
